export const content = {
  ressourcenWaehlen: 'Ressourcen auswählen',
  manuellerAusschreibungsprozess: 'Manueller Ausschreibungsprozess',
  ausschreibungsprozessTooltip:
    'Die Art des Ausschreibungsprozesses wird aus dem Thema vererbt und kann nicht in der Veranstaltung geändert werden.',
};
